import React from 'react'
import "../css/common.sass";

const StatusLabel = ({status}) => {
  return (
    <div className={`label-container ${status}`}>{status}</div>
  )
}

export default StatusLabel